export const TabTitle = (newTitle) => {
  if (document.title.includes("|"))
    return (document.title = document.title.split("|")[0] + newTitle);
  else return (document.title += newTitle);
};
